export type TextSizeKey = 'short' | 'medium'

export type TextSizeConfigItem = {
  max: number
  warnAt: number
}

export const TEXT_SIZE_CONFIG: Record<TextSizeKey, TextSizeConfigItem> = {
  short: { max: 150, warnAt: 80 },
  medium: { max: 800, warnAt: 400 },
  // future use cases
  //large: { max: 8000, warnAt: 4000 },
  //huge: { max: 25000, warnAt: 20000 },
}

// Threshold for when to switch from inline editing to a larger editor (e.g., popover/modal)
export const INLINE_MAX_CHARS_THRESHOLD = TEXT_SIZE_CONFIG.short.max

export const getTextSizeForMax = (m?: number): TextSizeKey | undefined => {
  if (typeof m !== 'number') return undefined
  if (m <= TEXT_SIZE_CONFIG.short.max) return 'short'
  return 'medium'
}
